import styled from "styled-components";

export const PSRemainingBoxWrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  margin: 1em 0 2em 0;
`;
export const ToWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: repeat(2, 1fr);
  gap: 0.5em;
  .toLabel {
    font-weight: 500;
    font-size: 16px;
  }
  .toValue {
    color: var(--accent);
    font-weight: 600;
  }
`;
